module.exports = __webpack_public_path__ + "img/huodong_img.71c5002b.png";